// extracted by mini-css-extract-plugin
export var indianLeadershipSection = "IndianLeadershipTeamNew-module--indianLeadershipSection--mKELm";
export var sectionTitle = "IndianLeadershipTeamNew-module--sectionTitle--Ammqa";
export var teamGrid = "IndianLeadershipTeamNew-module--teamGrid--6vXnm";